<script>
	let utilities = require('utilities');
	var routeContext = require('core/routeContext');

	module.exports = {
		data: function () {
			return {
				routeContext
			};
		},
		methods: {
			forceLogin: function () {
				utilities.openModal('#teacher-login-modal');
			}
		},
		computed: {
			url: function () {
				let pathname = this.routeContext.pathname;
				if (pathname) {
					return '?url=' + pathname;
				}
				return '';
			}
		}
	};
</script>
<style lang="scss">
	.article-paywall {
		.student-link {
			margin-top: 0.25rem;
			display: inline-block;
		}
	}
</style>
<template>
	<div class="article-paywall">
		<div class="article-fader"></div>
		<div class="paywall-signup-link text-muted">
			Educators only. For full, free access:
			<div class="button-wrapper">
				<button
					class="button -medium"
					@click="forceLogin">
					Log In
				</button>
				or
				<a
					:href="`/teacher-signup${url || ''}`"
					class="button -medium">
					Sign Up
				</a>
			</div>
			<a
				href="/student-authentication"
				class="student-link">
				I'm a student
			</a>
		</div>
	</div>
</template>
